/**
 * Registers all AG Grid modules needed by the Rules, RuleSets, and TagSpecs grids.
 * Import this module once (it is cached by the JS module system) instead of calling
 * ModuleRegistry.registerModules in every grid component.
 */
import {
    ColumnApiModule,
    ColumnMenuModule,
    ColumnsToolPanelModule,
    MasterDetailModule,
    ModuleRegistry,
    RenderApiModule,
    ValidationModule,
} from 'ag-grid-enterprise';
import { ExternalFilterModule } from 'ag-grid-community';

ModuleRegistry.registerModules([
    ExternalFilterModule,
    ColumnApiModule,
    RenderApiModule,
    ValidationModule,
    ColumnsToolPanelModule,
    ColumnMenuModule,
    MasterDetailModule,
]);
